<div class="player-container">
  <div class="row">
    <div class="player-thumbnail col-3">
      <img src="{{campaignConstants.POP_IMG}}" alt="">
    </div>
    <div class="player-credit-container col-9">
      <p class="album">Rae Street</p>
      <p class="author">Courtney Barnett</p>
      <div class="progress-container">
        <button (click)="onClickPlay()" *ngIf="play" class="play"><i class="fa fa-play" aria-hidden="true"></i></button>
        <button (click)="onClickPause()" *ngIf="pause" class="pause"><i class="fa fa-pause"
            aria-hidden="true"></i></button>
        <div class="progress-bar">
          <div class="progress" id="progress"></div>
        </div>
        <div class="duration">{{timerMin}}:{{this.timeSec}}</div>
      </div>
    </div>
  </div>
</div>